module.exports = __webpack_public_path__ + "static/media/Anxiety.9ca51a91.svg";